import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightLocationLookup } from '../../api/models';

export type TABLE_TYPE = Table<HeadWeightLocationLookup>;

export const TABLE = 'headWeightLocationLookup';
const SCHEMA = 'headWeightLocationLookupId, sortId';

class HeadWeightLocationLookupDatabase implements DataRepository<HeadWeightLocationLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightLocationLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightLocationLookup, key: Key): Promise<HeadWeightLocationLookup> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightLocationLookup[]): Promise<HeadWeightLocationLookup[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightLocationLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const HeadWeightLocationLookupDB = new HeadWeightLocationLookupDatabase(db);
